module.exports = __webpack_public_path__ + "img/DSC_2728.f71510f9.png";